import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

const BlurText = ({ text, className, highlightWords = [], highlightClassName = 'text-[#FF6E00]' }) => {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const words = text.split(' ');
  const normalized = highlightWords.map((w) => w.toLowerCase());

  return (
    <p
      ref={containerRef}
      className={`flex flex-wrap justify-center row-gap-[0.1em] ${className || ''}`}
      style={{ rowGap: '0.1em' }}
    >
      {words.map((word, i) => {
        const isHighlighted = normalized.includes(word.toLowerCase());
        return (
          <motion.span
            key={`${word}-${i}`}
            className={isHighlighted ? highlightClassName : undefined}
            style={{ display: 'inline-block', marginRight: '0.28em' }}
            initial={{ filter: 'blur(10px)', opacity: 0, y: 50 }}
            animate={
              visible
                ? {
                    filter: ['blur(10px)', 'blur(5px)', 'blur(0px)'],
                    opacity: [0, 0.5, 1],
                    y: [50, -5, 0],
                  }
                : { filter: 'blur(10px)', opacity: 0, y: 50 }
            }
            transition={{
              duration: 0.7,
              times: [0, 0.5, 1],
              ease: 'easeOut',
              delay: (i * 100) / 1000,
            }}
          >
            {word}
          </motion.span>
        );
      })}
    </p>
  );
};

export default BlurText;
